export const WASHINGTON_STATE_SALES_TAX = 0.09;
